import dateFnsGenerateConfig from '@rc-component/picker/generate/dateFns';
import generateCalendar from 'antd/es/calendar/generateCalendar';
import generatePicker from 'antd/es/date-picker/generatePicker';
import type { DatePickerDateType } from './date-utilities';

// eslint-disable-next-line @typescript-eslint/naming-convention -- It is component
export const BaseDatePicker = generatePicker<DatePickerDateType>(dateFnsGenerateConfig);

// eslint-disable-next-line @typescript-eslint/naming-convention -- It is component
export const BaseCalendar = generateCalendar<DatePickerDateType>(dateFnsGenerateConfig);
